import { createProvider } from '@frontend/store';
import { KeywordSearchContextValue } from './types';

export const { Provider: KeywordSearchProvider, useStore: useKeywordSearchStore } =
  createProvider<KeywordSearchContextValue>()((set) => ({
    attachmentType: null,
    sender: [],
    inConversations: [],
    isSearching: false,
    keyword: '',

    setAttachmentType: (value) => set(() => ({ attachmentType: value })),
    setSender: (value) => set(() => ({ sender: value })),
    setInConversations: (value) => set(() => ({ inConversations: value })),
    setIsSearching: (value) => set(() => ({ isSearching: value })),
    setKeyword: (value) => set(() => ({ keyword: value })),

    startSearch: (keyword) =>
      set((state) => ({
        ...(state.keyword !== keyword && { keyword }),
        ...(!state.isSearching && { isSearching: true }),
      })),

    clearSearch: () => set((state) => ({ keyword: '', ...(state.isSearching && { isSearching: false }) })),
  }));
